var map = {
	"./BetoTemplate/BetoTemplate": [
		96942,
		6942
	],
	"./DefaultTemplate/DefaultTemplate": [
		21999,
		1999
	],
	"./TopiaTemplate/TopiaTemplate": [
		93070
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 89753;
module.exports = webpackAsyncContext;